const schema = () => {
  /* 
    this is a hack to fix the dropdown boxes not appearing at more than one sub level
    this was happening due to the "lazy loading" of the schema when using $refs 
    no idea why this bug is occurring in the JSONEditor but this is the only fix I could find
    a similar issue was raised here, but as of time of writing the issue is still unsolved
    https://github.com/josdejong/jsoneditor/issues/473
  */
  const depth = 0;
  return {
    $id: "http://slotting.combinedarms.co.uk/schemas/schema.json",
    type: "object",
    properties: {
      event_id: {
        type: "number",
        // minimum: Number(id),
        // maximum: Number(id),
      },
      total_slots: {
        type: "number",
      },
      filled_slots: {
        type: "number",
      },
      event: {
        type: "object",
        additionalProperties: true,
        properties: {
          event_owner: {
            type: "string",
            minLength: 1,
          },
          event_repo: {
            type: "string",
            enum: ["MAIN", "VANILLAPLUS", "SPECIAL", "JOINT", "WW2", "TEST"],
          },
          event_reserves: {
            type: "array",
          },
          event_title: {
            type: "string",
            minLength: 1,
            maxLength: 50,
          },
          event_date: {
            type: "string",
            pattern:
              "20[0-9]{2}-[0|1]{1}[0-9]{1}-[0|1|2|3]{1}[0-9]{1}T[0-9]{2}:[0-9]{2}:[0-9]{2}Z",
          },
        },
        required: [
          "event_owner",
          "event_repo",
          "event_reserves",
          "event_title",
        ],
      },
      sides: sidesSchema({ depth }),
    },
    required: ["sides", "event"],
  };
};

const sidesSchema = ({ depth }) => ({
  type: "array",
  minItems: 1,
  items: {
    type: "object",
    additionalProperties: false,
    properties: {
      side: {
        type: "string",
        enum: ["BLU", "RED", "IND", "CIV"],
      },
      groups: groupsSchema({ depth }),
    },
    required: ["side", "groups"],
  },
});

//while groupsSchema and childrenSchema are virtually the same, we have to
//split them as groups must contain at least one item and there is no
//way to conditionally do this
const groupsSchema = ({ depth }) => ({
  type: "array",
  minItems: 1,
  items: {
    type: "object",
    additionalProperties: false,
    properties: {
      group_data: groupDataSchema(),
      slots: slotSchema(),
      child: childrenSchema({ depth }),
      relationship: { type: "string" },
    },
    required: ["group_data", "slots", "child"],
  },
});

const childrenSchema = ({ depth }) => {
  depth++;
  //max depth of 10, doubt we'll need more
  //see hack description at top for reason why this was done
  if (depth > 10) {
    return {};
  }
  return {
    type: "array",
    items: {
      type: "object",
      additionalProperties: false,
      properties: {
        group_data: groupDataSchema(),
        slots: slotSchema(),
        child: childrenSchema({ depth }),
        relationship: {
          type: "string",
        },
      },
      required: ["group_data", "slots", "child"],
    },
  };
};

const groupDataSchema = () => ({
  type: "object",
  properties: {
    group_name: {
      type: "string",
      minLength: 1,
    },
    group_orbat_icon: groupIconSchema(),
    group_gear: {
      type: "string",
    },
    group_callsign: {
      type: "string",
    },
    group_background: {
      type: "string",
      enum: [
        "WHITE",
        "BLUE",
        "RED",
        "YELLOW",
        "GREEN",
        "GREY",
        "PURPLE",
        "DEFAULT",
      ],
    },
  },
  required: [
    "group_name",
    "group_orbat_icon",
    "group_gear",
    "group_callsign",
    "group_background",
  ],
});

const groupIconSchema = () => ({
  type: "string",
  enum: [
    "nato_aa",
    "nato_aagun",
    "nato_aamissile",
    "nato_armour",
    "nato_art",
    "nato_at",
    "nato_eng",
    "nato_fixedwing",
    "nato_inf",
    "nato_infmech",
    "nato_med",
    "nato_mtr",
    "nato_naval",
    "nato_para",
    "nato_rec",
    "nato_rotary",
    "nato_sf",
    "nato_sig",
    "nato_supply",
    "nato_uav",

    "opf_aa",
    "opf_aagun",
    "opf_aamissile",
    "opf_armour",
    "opf_art",
    "opf_at",
    "opf_eng",
    "opf_fixedwing",
    "opf_inf",
    "opf_infmech",
    "opf_med",
    "opf_mtr",
    "opf_naval",
    "opf_para",
    "opf_rec",
    "opf_rotary",
    "opf_sf",
    "opf_sig",
    "opf_supply",
    "opf_uav",

    "ind_aa",
    "ind_aagun",
    "ind_aamissile",
    "ind_armour",
    "ind_art",
    "ind_at",
    "ind_eng",
    "ind_fixedwing",
    "ind_inf",
    "ind_infmech",
    "ind_med",
    "ind_mtr",
    "ind_naval",
    "ind_para",
    "ind_rec",
    "ind_rotary",
    "ind_sf",
    "ind_sig",
    "ind_supply",
    "ind_uav",

    "civ_blank",
    "civ_humanitarian",
    "civ_med",
    "civ_press",
    "civ_spy",
  ],
});

// const playerSchema = () => ({
//   type: "object",
//   properties: {
//     player_id: "string",
//     player_name: "string",
//   },
//   required: ["player_id", "player_name"],
// });

const slotSchema = () => ({
  type: "array",
  items: {
    type: "object",
    properties: {
      slot_id: {
        type: "string",
        minLength: 1,
      },
      slot_name: {
        type: "string",
        minLength: 1,
      },
      //todo fix this as it says it's invalid schema
      //slot_player: playerSchema(),
      slot_shortcode: {
        type: "string",
        maxLength: 10,
      },
      slot_gear: {
        type: "string",
      },
      slot_restricted: {
        type: "boolean",
      },
      slot_locked: {
        type: "boolean",
      },
      slot_icon_code: {
        type: "string",
        enum: ["CO", "OFFICER", "SL", "AT", "AR", "MED", "DEMO", "ENG", "MAN"],
      },
      slot_dlc: {
        type: "array",
        items: {
          type: "string",
          enum: [
            "APEX",
            "JETS",
            "HELICOPTERS",
            "KARTS",
            "MARKSMAN",
            "TANKS",
            "LAWSOFWAR",
            "GLOBALMOB",
            "CONTACT",
            "SOGPF",
            "IRONCURTAIN",
            "ARTOFWAR",
          ],
        },
      },
    },
    required: [
      "slot_name",
      // "slot_player",
      "slot_shortcode",
      "slot_gear",
      "slot_restricted",
      "slot_icon_code",
      "slot_dlc",
    ],
  },
});

export default schema;
